module.exports = __webpack_public_path__ + "media/images/shop/rectangle-240f52d4a2bf2a801d79c284d7135da3.png";